import api from '../index'

export interface TeamOwner {
  id: number
  username: string
  mobile: string
  user_team_id?: number
  status?: number
}

export interface TeamPackage {
  id: number
  user_team_id: number
  package_id: number
  source?: number
  request_no?: string
  remark?: string
  start_time?: string
  expire_time?: string
  max_user_count?: number
  status?: number
  package?: {
    id: number
    name: string
  }
}

export interface Team {
  id: number
  user_id: number
  name: string
  code: string
  current_package_id?: number | null
  package_start_time?: string | null
  package_expire_time?: string | null
  package_status?: 0 | 1 | 2
  created_at?: string
  updated_at?: string
  owner?: TeamOwner
  team_packages?: TeamPackage[]
}

export interface TeamListParams {
  keyword?: string
  package_status?: 0 | 1 | 2
  page?: number
  pageSize?: number
}

export default {
  list: (params?: TeamListParams) => api.get('team/list', { params }),
}
